import { createAsyncTypes } from './mutation-types'

export default {
  GET_TOKEN: createAsyncTypes('GET_TOKEN'),
  POST_LOGIN: createAsyncTypes('POST_LOGIN'),
  POST_REFRESH: createAsyncTypes('POST_REFRESH'),
  GET_USER: createAsyncTypes('GET_USER'),
  GET_HCP: createAsyncTypes('GET_HCP'),
  GET_USER_BY_ID: createAsyncTypes('GET_USER_BY_ID'),
  GET_USERS: createAsyncTypes('GET_USERS'),
  SEARCH: createAsyncTypes('SEARCH'),
  PUT_USER: createAsyncTypes('PUT_USER'),
  POST_USER: createAsyncTypes('POST_USER'),
  PATCH_USER: createAsyncTypes('PATCH_USER'),
  POST_EMAIL_VERIFICATION: createAsyncTypes('POST_EMAIL_VERIFICATION'),
  GET_RESET_PASSWORD: createAsyncTypes('GET_RESET_PASSWORD'),
  POST_RESET_PASSWORD: createAsyncTypes('POST_RESET_PASSWORD'),
  GET_PARENTAL_CONSENT: createAsyncTypes('GET_PARENTAL_CONSENT'),
  POST_PARENTAL_CONSENT: createAsyncTypes('POST_PARENTAL_CONSENT'),
  POST_PARENTAL_CONSENT_EMAIL: createAsyncTypes('POST_PARENTAL_CONSENT_EMAIL'),
  GET_DASHBOARD: createAsyncTypes('GET_DASHBOARD'),
  GET_KITS: createAsyncTypes('GET_KITS'),
  GET_COMP_KITS_WITH_RESULTS: createAsyncTypes('GET_COMP_KITS_WITH_RESULTS'),
  GET_KITS_BY_USER_ID: createAsyncTypes('GET_KITS_BY_USER_ID'),
  GET_SENT_KITS: createAsyncTypes('GET_SENT_KITS'),
  GET_SENT_KITS_BY_USER_ID: createAsyncTypes('GET_SENT_KITS_BY_USER_ID'),
  POST_KIT_ACTIVATION: createAsyncTypes('POST_KIT_ACTIVATION'),
  DELETE_KIT_SHIPPING: createAsyncTypes('DELETE_KIT_SHIPPING'),
  POST_ORDER: createAsyncTypes('POST_ORDER'),
  GET_SURVEY: createAsyncTypes('GET_SURVEY'),
  PUT_SAMPLE: createAsyncTypes('PUT_SAMPLE'),
  GET_KIT_TIMELINE: createAsyncTypes('GET_KIT_TIMELINE')
}
